// extracted by mini-css-extract-plugin
module.exports = {"popover-list":"style_popover-list__14lHb"};